import { GeneralModel } from "../models/index";

export class HubRoutingCreateUpdateViewModel extends GeneralModel {
    hubId: number;
    userId: number;
    codeConnect: string;
    radiusServe: number;
    isTruckDelivery: boolean;
    wardIds: number[];
    streetJoinIds?: number[];
    responsibleUserId: number;
    supportUserId: number;
    customerIds: number[];
    isNew: boolean;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/view-model/hubRoutingCreateUpdate.viewModel.ts